import { formatNumber } from '@/utils/number-format';

export function useOddsFormat(oddsValue: number) {
  if (Number(oddsValue) > 0) {
    return formatNumber(oddsValue, true);
  }
  return null;
}
